import React from 'react';
import styled from 'styled-components';
import Accordion from 'components/Accordion';

type VideoItem = {
	id: string | number;
	title: string;
	youtubeId: string;
};

const videos: VideoItem[] = [
	{ id: 1, title: 'Clique aqui para assistir ao vídeo tutorial', youtubeId: 'EXcSf79PEgg' },
];

export default function FaqVideosSection() {
	return (
		<Container>
			<Wrapper>
				{videos.map((video) => (
					<Accordion key={video.id} title={video.title}>
						<VideoContainer>
							<iframe
								src={`https://www.youtube.com/embed/${video.youtubeId}`}
								title={video.title}
								frameBorder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
								allowFullScreen
							/>
						</VideoContainer>
					</Accordion>
				))}
			</Wrapper>
		</Container>
	);
}

const Container = styled.div`
  margin-top: 3rem;
	width: 100%;
	max-width: 800px;
	margin-left: auto;
	margin-right: auto;
	padding: 0 1rem;

	@media (max-width: 768px) {
		padding: 0 0.5rem;
	}
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  min-height: 200px;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
    border-radius: 8px;
  }

  @media (max-width: 768px) {
    min-height: 250px;
  }
`;


